import React, { useState, useEffect } from "react";
import RigthPanel, { RigthPanelType } from "@/ui-controls/RigthPanel";
import { AuditRecord } from "@/api/audits";
import AuditRecordDetailsDiff from "@/components/audits/AuditRecordDetailsDiff";

interface Props {
  record: AuditRecord | undefined;
  onClosePanel: () => any;
}

const AuditDetailsPanel = (props: Props) => {
  const onCloseNewAppPanel = () => {
    setIPanelOpen(false);
    props.onClosePanel();
  };

  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  useEffect(() => {
    if (props.record) {
      setIPanelOpen(true);
    } else {
      onCloseNewAppPanel();
    }
  }, [props.record]);

  return (
    <>
      <RigthPanel
        header="Audit Details"
        isOpen={isPanelOpen}
        type={RigthPanelType.large}
        dismissPanel={onCloseNewAppPanel}
        childComponent={AuditRecordDetailsDiff}
        childProps={{
          onClose: () => onCloseNewAppPanel(),
          AuditRecord: props.record,
        }}
      ></RigthPanel>
    </>
  );
};

export default AuditDetailsPanel;
